import { useQuery } from "@tanstack/react-query";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { matterFileMoveQueryOptions } from "@/lib/data/react-query/file-library";
import { automationError } from "@/components/features/automations/automationError";
import { LibraryMoveDialog } from "./LibraryMoveDialog";
export function MatterFileMoveDialog({
  id,
  name,
  onClose,
}: {
  id: string;
  name: string;
  onClose: () => void;
}) {
  const source = useQuery({
    ...matterFileMoveQueryOptions(id),
    refetchOnWindowFocus: false,
  });
  if (source.data)
    return (
      <LibraryMoveDialog
        item={{ ...source.data, name, scope: "matter" }}
        onClose={onClose}
      />
    );
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Move {name}</DialogTitle>
        </DialogHeader>
        <p role={source.error ? "alert" : "status"}>
          {source.error ? automationError(source.error) : "Loading file…"}
        </p>
      </DialogContent>
    </Dialog>
  );
}
